/**
 * Created by Mikhail Menshenin on 09.07.2024
 */

const HutView = cc.Node.extend({
    avoidNode: "HutView",

    ctor: function (hut) {
        this._super();
        this.hut = hut;

        this.setAnchorPoint(0.5, 0.5);

        this.createImage();

        if (this.hut.canBuild()) {
            this.createIcon();
        }

        if (this.hut.village.canAttack() && this.hut.canAttack()) {
            this.createScope();
        }

        cleverapps.UI.wrap(this);

        this.hut.setUpgradeTool(false);
        this.checkUpgradeable();
        this.setupChildren();

        hut.on("changeLevel", this.updateImage.bind(this), this);
        hut.on("upgrade", this.upgradeAnimation.bind(this), this);
        hut.on("attack", this.attackAnimation.bind(this), this);
        hut.on("changeUpgradeable", this.checkUpgradeable.bind(this), this);
        hut.on("setUpgradeTool", this.updateUpgradeTool.bind(this), this);
    },

    createIcon: function () {
        const styles = cleverapps.styles.HutView;
        const icon = new cc.Sprite(bundles.village.frames.build_png);
        icon.setScale2(styles.icon.scale);
        this.iconControl = VillageSceneComponent.AddControl(this, icon, {
            direction: HidingComponent.DIR.NONE,
            control: `buildIcon${this.hut.id}`
        }, styles.icon);
        this.iconControl.setLocalZOrder(10);
        this.icon = icon;
    },

    checkClick: function (touch, isDouble) {
        const icon = this.icon || this.targetIcon;
        if (icon) {
            const size = icon.getContentSize();
            const rect = cc.rect(0, 0, size.width, size.height);
            if (cc.rectContainsPoint(rect, icon.convertToNodeSpace(touch.getLocation())) || cc.rectContainsPoint(rect, icon.convertToNodeSpace(touch.getStartLocation()))) {
                if (isDouble) {
                    this.hut.onDoubleClick();
                } else {
                    this.hut.onClick();
                }
                return true;
            }
        }
        return false;
    },

    updateUpgradeTool: function (isOpen) {
        if (!isOpen && this.bg) {
            this.bg.runAction(new cc.Sequence(
                new cc.Spawn(
                    new cc.ScaleTo(0.2, 0),
                    new cc.MoveBy(0.2, 0, -this.bg.height / 2)
                ),
                new cc.CallFunc(() => {
                    this.bg.removeFromParent();
                    delete this.bg;
                })
            ));
        }
        if (isOpen && !this.bg) {
            const bg = this.bg = this.createUpgradeTool();

            bg.setScale(0);
            bg.runAction(new cc.Spawn(
                new cc.MoveBy(0, 0, -bg.height / 2),
                new cc.ScaleTo(0.2, 1),
                new cc.MoveBy(0.2, 0, bg.height / 2)
            ));
        }
    },

    createUpgradeTool: function () {
        const styles = cleverapps.styles.HutView;
        const bg = cleverapps.UI.createScale9Sprite(bundles.village.frames.upgrade_bg);
        bg.setContentSize(styles.upgrade);
        bg.setAlignment(styles.upgrade);
        this.addChild(bg, 10);

        const stars = [];
        const starFrame = bundles.village.frames.star_png;
        const starShadowFrame = bundles.village.frames.star_shadow_png;
        for (let i = 0; i < this.hut.getMaxLevel(); i++) {
            const star = new cc.Sprite(i < this.hut.level ? starFrame : starShadowFrame);
            star.setAnchorPoint(0.5, 0.5);
            star.setScale(styles.upgrade.stars.scale);
            stars.push(star);
        }
        const layout = new cleverapps.Layout(stars, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.upgrade.stars.margin
        });
        layout.setAlignment(styles.upgrade.stars);
        bg.addChild(layout);

        const price = this.hut.getPrice();
        const priceText = TextWithIcon.ICONS_BY_NAME[price.type] + aisensia.getNumberWithCommas(price.amount);
        const priceNode = new TextWithIcon(priceText, {
            margin: styles.upgrade.text.margin,
            font: cleverapps.styles.FONTS.HUT_PRICE_TEXT
        });
        priceNode.fitTo(styles.upgrade.width - styles.upgrade.padding);
        priceNode.setAlignment(styles.upgrade.text);
        bg.addChild(priceNode);

        return bg;
    },

    createScope: function () {
        const styles = cleverapps.styles.HutView;
        const targetIcon = this.targetIcon = new HutScopeView(this.hut);
        VillageSceneComponent.AddControl(this, targetIcon, {
            direction: HidingComponent.DIR.NONE,
            control: `villageScope${this.hut.id}`
        }, styles.scope);
    },

    setupChildren: function () {
        const styles = cleverapps.styles.HutView;
        const positions = styles.villages[this.hut.village.level] || styles.villages[this.hut.village.level % 2];
        const position = positions[this.hut.id];
        this.setAlignment(position);
    },

    createImage: function () {
        const styles = cleverapps.styles.HutView.image;
        const frame = this.hut.getFrame();
        if (frame) {
            this.image = new cc.Sprite(frame);
            this.image._debugExclude = true;
            this.image.setAlignment(styles);
            this.addChild(this.image);
            cleverapps.UI.wrap(this);
        } else {
            this.image = undefined;
        }
    },

    updateImage: function () {
        if (this.image) {
            this.image.removeFromParent();
        }

        this.createImage();
    },

    upgradeAnimation: function (price, f) {
        this.animateChangeLevel(f);
    },

    animateChangeLevel: function (callback) {
        let oldImage = this.image;
        this.createImage();

        if (!oldImage) {
            oldImage = new cc.Node();
            oldImage.setContentSize2(this.image.getContentSize());
            oldImage.setPosition(this.image.getPosition());
            this.addChild(oldImage);
            oldImage.setVisible(false);
        }

        if (this.hut.isDestroyed()) {
            this.image.setVisible(false);
            oldImage.runAction(new cc.Spawn(
                StandartAnimations.disappear(oldImage, {
                    dust: true,
                    keepVisible: false
                }),
                new cc.Sequence(
                    new cc.DelayTime(0.6),
                    new cc.CallFunc(() => {
                        this.image.setVisible(true);
                        callback && callback();
                    })
                )
            ));
        } else {
            this.toggleIcon(false);
            oldImage.runAction(StandartAnimations.upgrade(oldImage, this.image)).setFinalize(() => {
                this.toggleIcon(!this.hut.isComplete());
                if (this.hut.village.upgradeTool) {
                    this.hut.setUpgradeTool(true);
                }
                callback && callback();
            });
        }
    },

    attackAnimation: function (f) {
        this.animateChangeLevel(f);

        const styles = cleverapps.styles.HutView;
        const spine = new cleverapps.Spine(bundles.village.jsons.small_lightning_json);
        spine.setAlignment(styles.lightning);
        this.addChild(spine);
        spine.setAnimation(0, "animation", false);
        spine.setCompleteListenerRemove();

        const smoke = new cleverapps.Spine(bundles.village.jsons.smoke_json);
        smoke.setAlignment(styles.smoke);
        smoke.setLocalZOrder(-1);
        this.addChild(smoke);
        smoke.runAction(new cc.Sequence(
            new cc.Hide(),
            new cc.DelayTime(0.2),
            new cc.Show(),
            new cc.CallFunc(() => {
                smoke.setAnimation(0, "smoke", true);
            })
        ));
    },

    checkUpgradeable: function () {
        if (this.icon) {
            if (this.hut.upgradeable) {
                this.icon.setSpriteFrame(bundles.village.frames.build_png);
            } else {
                this.icon.setSpriteFrame(bundles.village.frames.build_grey_png);
            }
            this.toggleIcon(!this.hut.isComplete(), true);
        }
    },

    toggleIcon: function (visible, silent) {
        if (this.iconControl) {
            const hiding = ComponentMap.get(this.iconControl, HidingComponent);
            hiding.toggle(visible && !this.hut.village.isFirstInit() && !this.hut.village.isFirstUpgrade(), silent);
        }
    },

    spawn: function () {
        this.runAction(new cc.Sequence(
            new cc.Hide(),
            new cc.DelayTime(this.hut.id * 0.2),
            StandartAnimations.showUp(this)
        ));
    }
});

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    HUT_PRICE_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        name: "nostroke"
    }
});

cleverapps.styles.HutView = {
    width: [300, 390, 420],
    height: [300, 252, 252],

    icon: {
        x: { align: "center" },
        y: { align: "center" },
        scale: [0.73, 0.57, 0.57]
    },

    upgrade: {
        x: { align: "center" },
        y: { align: "center", dy: 100 },
        width: 225,
        height: 100,
        padding: 30,

        stars: {
            margin: 5,
            x: { align: "center" },
            y: { align: "center", dy: -15 },
            scale: 0.6
        },

        text: {
            x: { align: "center" },
            y: { align: "center", dy: 20 },
            margin: 10
        }
    },

    villages: [],

    attention: {
        x: { align: "right", dx: -20 },
        y: { align: "top", dy: -20 },

        scale: 0.5
    },

    image: {
        x: { align: "center" },
        y: { align: "center" }
    },

    scope: {
        x: { align: "center" },
        y: { align: "center" }
    },

    lightning: {
        x: { align: "center" },
        y: { align: "center" }
    },

    smoke: {
        x: { align: "center" },
        y: { align: "center" }
    }
};

RestoreProgressButton.OverlappingNodes = RestoreProgressButton.OverlappingNodes.concat("HutView");